import ButtonFactory from "@components/Button/ButtonFactory";
import { ButtonType } from "@components/Button/utils/types";
import useSendDataToGTM from "@features/analytics/hooks/useSendDataToGTM";
import useFeedbackFormUrl from "@hooks/useFeedbackFormUrl";

import { newspostUrl, nonSphText, sphText } from "./constants";
import { ArticlePurchaseLinkProps } from "./types";

export default function ArticlePurchaseLinkVersion2({
  title,
  publishedDate,
  displayPurchase,
}: ArticlePurchaseLinkProps): React.ReactElement {
  const sendDataToGTM = useSendDataToGTM();
  const date = encodeURIComponent(publishedDate);
  const encodedTitle = encodeURIComponent(title);
  const sourceUrl = useFeedbackFormUrl();
  const onClickTriggerGa = (eventLabel: string) => {
    const eventCategory = displayPurchase ? "copyright" : "feedback";

    sendDataToGTM({
      event: "custom_event",
      eventCategory: eventCategory,
      eventAction: "click",
      eventLabel: eventLabel,
    });
  };

  return (
    <section
      className="mx-auto flex w-full flex-wrap items-center justify-between gap-4 lg:gap-0"
      data-testid="article-purchase-link-version-2-component"
    >
      <p className="mb-0 font-public-sans text-xs tracking-0">
        {displayPurchase ? sphText : nonSphText}
      </p>

      <div className="flex flex-wrap gap-3 md:gap-0">
        {displayPurchase ? (
          <ButtonFactory
            buttonType={ButtonType.Link}
            onClick={() => {
              onClickTriggerGa("purchase article");
            }}
            link={`${newspostUrl}?publication=BT&title=${encodedTitle}&date=${date}`}
            mask={ButtonType.Secondary}
            text="Reuse this content"
            className="w-fit-content mr-4 !no-underline"
          />
        ) : null}

        <ButtonFactory
          buttonType={ButtonType.Link}
          onClick={() => {
            onClickTriggerGa("contact us");
          }}
          link={sourceUrl}
          mask={ButtonType.Secondary}
          text="Feedback"
          className="w-fit-content !no-underline"
        />
      </div>
    </section>
  );
}
